<template>
  <TitleCtaContainer :cta="ctaLink" :secondary-layout="true" :subtitle :title>
    <RevCardGrid :cards :layout="gridLayout">
      <template #default="{ card }">
        <ModularCard
          :key="card.id"
          :background="card.background"
          :blockPosition
          :blockTitle="title"
          :card-position="cardPosition(card)"
          class="h-full"
          :fixed-width="false"
          :link="card.link"
          :sections="card.sections"
          :size
          :technical-name="card.technicalName"
          :tracking
          :with-padding="cardsHavePadding"
        />
      </template>
    </RevCardGrid>
  </TitleCtaContainer>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type {
  ModularCard as ModularCardT,
  ModularCardsCarouselProps,
} from '@backmarket/http-api/src/api-specs-content/models/modular-card'
import { RevCardGrid } from '@ds/components/CardGrid'

import type { ContentBlockProps } from '../../models/content-block'
import TitleCtaContainer from '../../shared-components/TitleCtaContainer/TitleCtaContainer.vue'

import ModularCard from './ModularCard.vue'

const props = withDefaults(
  defineProps<
    Omit<ModularCardsCarouselProps, 'layout' | 'desktopLayout'> &
      ContentBlockProps
  >(),
  {
    mobileScreenColumns: 1,
  },
)

const cardPosition = (card: ModularCardT) =>
  props.cards.findIndex((c) => c.id === card.id) + 1

const gridLayout = computed(() => {
  return props.mobileScreenColumns === 2 ? 'fluid' : 'responsive'
})
</script>
